module.exports = __webpack_public_path__ + "static/media/outlook-contact.e39329ff.svg";